import {
  ConfirmModalOptions,
  ConfirmFunction,
} from './ConfirmModalManager';

let globalConfirmFunction: ConfirmFunction | null = null;

export const setGlobalConfirmFunction = (fn: ConfirmFunction) => {
  globalConfirmFunction = fn;
};

export const showConfirmModal = (options: ConfirmModalOptions): Promise<void | string> => {
  if (!globalConfirmFunction) {
    throw new Error(
      'Global confirm function not set. Make sure you have a ConfirmModalProvider in your component tree.',
    );
  }
  return globalConfirmFunction(options);
};
